// extracted by mini-css-extract-plugin
export default {"progress-loader":"FullLoading_progress-loader__Mp4OY","progress":"FullLoading_progress__2hUiC","loading1274":"FullLoading_loading1274__6tjDu"};